// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PostMenu__item--admin":"ra_a","PostMenu__item--moderator":"ra_b","PostMenu__item--author":"ra_c"};